import { IAppThunksRegistry } from './types'

export const appThunksRegistry = {} as IAppThunksRegistry
